namespace $.$$ {

	export class $shm_dashboard_mentions extends $.$shm_dashboard_mentions {

		@ $mol_mem
		data() {
			const obj = new this.$.$shm_dashboard_data()
			obj.app_id = ()=> this.app_id()
			obj.file = ()=> this.file()
			obj.file_uri = ()=> this.file_uri()
			obj.file_token = ()=> this.$.$shm_ba_pb.file_token()
			obj.period = ()=> this.period()
			obj.tags_filter = ()=> this.tags_filter() as $shm_ba_data_filter
			obj.authors_filter = ()=> this.authors_filter() as $shm_ba_data_filter
			obj.sources_filter = ()=> this.sources_filter() as $shm_ba_data_filter
			obj.message_types_filter = ()=> this.message_types_filter() as $shm_ba_data_filter
			obj.source_types_filter = ()=> this.source_types_filter() as $shm_ba_data_filter
			obj.search_query = ()=> this.search_query()
			obj.search_mode = ()=> this.search_mode() as $shm_ba_data_search_mode
			obj.search_case_sensitive = ()=> this.search_case_sensitive()
			obj.chart_metric = ()=> this.chart_metric()
			obj.summary_indicators = ()=> this.summary_indicators()
			obj.chart_group = ()=> this.chart_group() as $shm_ba_chart_group
			obj.posts_sort = ()=> this.posts_sort()
			obj.posts_sort_order = ()=> this.posts_sort_order()
			obj.visible_tags = ()=> this.dashboard_model()?.visible_tags() ?? null
			obj.excluded_tags = ()=> this.dashboard_model()?.excluded_tags() ?? []
			return obj
		}

	}

}
